import React, {useEffect, useState} from "react";
import ExamService from "../../service/exam.service";
import PageNavigation from "../components/PageNavigation";
import ExamResults from "./ExamResults";

export default function ApplicationResult (){

    const [examList, setExamList] = useState([]);

    const [selectedExamId, setSelectedExamId] = useState("");

    useEffect(() => {
        ExamService.getExamsWithAssignments()
            .then((response) => {
                if (response) {
                    setExamList(response);
                }
            })
            .catch((error) => {
                console.error("Error fetching exams with assignments:", error);
                setExamList([]);
            });
    }, []);



    return (
        <React.Fragment>

            <PageNavigation main="Componen List" sub="Home" header="Application List" description="List of exams"/>
            <div className="card card-body shadow border-0 table-wrapper table-responsive mt-3">

                <select
                    className="form-select w-100"
                    aria-label="Message select example"
                    value={selectedExamId}
                    onChange={(e) => setSelectedExamId(e.target.value)}
                >
                    <option value="">Select...</option>
                    {examList.map((exam) => (
                        <option key={exam.id} value={exam.id}>
                            {exam.name}
                        </option>
                    ))}
                </select>
                <hr/>
                {
                    selectedExamId ? <ExamResults examId={selectedExamId}/> : null
                }
            </div>
        </React.Fragment>
    )
}